import { createRouter } from "@tanstack/react-router";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import { initSentryClient } from "./sentry.client";

// Create a new router instance
export const getRouter = () => {
	const router = createRouter({
		routeTree,
		context: {},

		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
	});

	// Initialize Sentry on client side
	if (!router.isServer) {
		initSentryClient(router);
	}

	return router;
};
